module.exports = __webpack_public_path__ + "media/images/icons/logo_geo-abee1fb5af351a8c992bb7057c68ee1c.svg";